import { Button, Input, Select, Flex, Divider, Row, InputNumber } from 'antd';
import React, { useEffect, useState } from "react";
import common_axios from "./../commonAxios";
import "./AdminRecipe.css";

const AdminRecipe = () => {
    const [recipes, setRecipes] = useState([]);
    const [productsForSelect, setProductsForSelect] = useState([]);

    const [usersForSelect, setUsersForSelect] = useState([]);
    const [recipesForSelect, setRecipesForSelect] = useState([]);
    const [ingredientsForSelect, setIngredientsForSelect] = useState([]);

    const [postName, setName] = useState("");
    const [postDC, setDC] = useState("");
    const [postLearningHours, setLearningHours] = useState("");
    const [postCraftingHours, setCraftingHours] = useState("");
    const [postIngredient1Id, setIngredient1Id] = useState(undefined);
    const [postIngredient2Id, setIngredient2Id] = useState(undefined);
    const [postIngredient3Id, setIngredient3Id] = useState(undefined);
    const [postIngredient1Amount, setIngredient1Amount] = useState("");
    const [postIngredient2Amount, setIngredient2Amount] = useState("");
    const [postIngredient3Amount, setIngredient3Amount] = useState("");
    const [postProductId, setProductId] = useState(undefined);

    const [postUserId, setUserId] = useState(undefined);
    const [postRecipeId, setRecipeId] = useState(undefined);

    useEffect(() => {
        loadRecipes();
        loadRecipesForSelect();
        loadProductsForSelect();
        loadUsersForSelect();
        loadIngredientsForSelect();
    }, []);

    const loadRecipes = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/Recipe/admin/`)
            .then(response => {
                setRecipes(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const loadRecipesForSelect = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/Recipe/admin/forSelect`)
            .then(response => {
                setRecipesForSelect(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const loadUsersForSelect = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/User/admin/forSelect`)
            .then(response => {
                setUsersForSelect(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const loadProductsForSelect = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/Product/forSelect`)
            .then(response => {
                setProductsForSelect(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const loadIngredientsForSelect = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/Ingredient/admin/forSelect`)
            .then(response => {
                setIngredientsForSelect(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const postRecipe = () => {
        common_axios.post(`${process.env.REACT_APP_API_URL}/Recipe/admin/`, {
            name: postName,
            ingredients: [postIngredient1Id, postIngredient2Id, postIngredient3Id],
            amounts: [postIngredient1Amount, postIngredient2Amount, postIngredient3Amount],
            productId: postProductId,
            dc: postDC,
            learningHours: postLearningHours,
            craftingHours: postCraftingHours
        }).then(() => {
            loadRecipes();
            loadRecipesForSelect();
        })
            .catch(error => {
                console.error(error);
            });
    }

    const postRecipeToUser = () => {
        common_axios.post(`${process.env.REACT_APP_API_URL}/RecipeToUser/`, {
            recipeId: postRecipeId,
            userId: postUserId,
            craftedAmount: 0,
            failedAmount: 0,
            learningProgress: 0,
            learned: false
        }).catch(error => {
            console.error(error);
        });
    }

    const deleteRecipe = (recipeId) => {
        common_axios.delete(`${process.env.REACT_APP_API_URL}/Recipe/admin/` + recipeId)
            .then(() => {
                loadRecipes();
                loadRecipesForSelect();
            })
            .catch(error => {
                console.error(error);
            });
    }

    const submitButton1Disabled = () => {
        //Check simple fields
        if (postName === "") return true;
        if (postDC === "") return true;
        if (postLearningHours === "") return true;
        if (postCraftingHours === "") return true;
        if (postIngredient1Id === undefined) return true;
        if (postIngredient1Amount === "") return true;
        if (postProductId === undefined) return true;

        //Check if Amounts for all ingredients are set
        if (postIngredient2Id !== undefined && (postIngredient2Amount === "" || postIngredient2Amount === 0)) return true;
        if (postIngredient3Id !== undefined && (postIngredient3Amount === "" || postIngredient3Amount === 0)) return true;

        //Check that there are no gaps in the ingredients
        if (postIngredient3Id !== undefined && postIngredient2Id === undefined) return true;

        return false;
    }

    return (
        <Flex className='flexWrapper' vertical>
            <Divider className='titleReadable' style={{ marginTop: "60px" }}>Recipe hinzufügen</Divider>

            <Flex vertical className='form'>
                <Input className='inputField mediumLarge' placeholder="Name" onChange={(value) => { setName(value.target.value); }} />
                <Input className='inputField' placeholder="DC" onChange={(value) => { setDC(value.target.value); }} />
                <Input className='inputField' placeholder="Hours To Learn" onChange={(value) => { setLearningHours(value.target.value); }} />
                <Input className='inputField' placeholder="Hours To Craft" onChange={(value) => { setCraftingHours(value.target.value); }} />

                <Row>
                    <Select
                        className='selectField'
                        showSearch
                        placeholder="Ingredient 1"
                        optionFilterProp="label"
                        onChange={value => setIngredient1Id(value)}
                        options={ingredientsForSelect}
                        allowClear
                    />
                    <InputNumber
                        onChange={(value) => setIngredient1Amount(value)}
                        min={1}
                        changeOnWheel
                    />
                </Row>
                <Row>
                    <Select
                        className='selectField'
                        showSearch
                        placeholder="Ingredient 2"
                        optionFilterProp="label"
                        onChange={value => setIngredient2Id(value)}
                        options={ingredientsForSelect}
                        allowClear
                    />
                    <InputNumber
                        onChange={(value) => setIngredient2Amount(value)}
                        min={1}
                        changeOnWheel
                    />
                </Row>
                <Row>
                    <Select
                        className='selectField'
                        showSearch
                        placeholder="Ingredient 3"
                        optionFilterProp="label"
                        onChange={value => setIngredient3Id(value)}
                        options={ingredientsForSelect}
                        allowClear
                    />
                    <InputNumber
                        onChange={(value) => setIngredient3Amount(value)}
                        min={1}
                        changeOnWheel
                    />
                </Row>

                <Select
                    className='selectField'
                    showSearch
                    placeholder="Select a potion"
                    optionFilterProp="label"
                    onChange={value => setProductId(value)}
                    options={productsForSelect}
                    allowClear
                />

                <Button className='buttonSubmit' disabled={submitButton1Disabled()} onClick={postRecipe}>Recipe erstellen</Button>
            </Flex>

            <Divider className='titleReadable' style={{ marginTop: "60px" }}>Recipe einem User hinzufügen</Divider>

            <Flex vertical className='form'>
                <Select
                    className='selectField'
                    showSearch
                    placeholder="Select a user"
                    optionFilterProp="label"
                    onChange={value => setUserId(value)}
                    options={usersForSelect}
                    allowClear
                />
                <Select
                    className='selectField'
                    showSearch
                    placeholder="Select a recipe"
                    optionFilterProp="label"
                    onChange={value => setRecipeId(value)}
                    options={recipesForSelect}
                    allowClear
                />

                <Button disabled={postUserId === undefined || postRecipeId === undefined} onClick={postRecipeToUser}>Recipe zu User hinzufügen</Button>
            </Flex>

            <Divider className='titleReadable' style={{ marginTop: "60px" }}>Recipe löschen</Divider>
            {recipes.map(item => (
                <div className='itemRecipe' key={item.id}>{item.recipe} {"==>"} {item.name} <Button onClick={() => deleteRecipe(item.id)}>X</Button></div>
            ))}
        </Flex>
    );
};

export default AdminRecipe;